export const constants = {
  restrictions: {
    title: "Restrictions",
    addButtonTitle: "Add Restriction",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No Restrictions added yet.",
  },
  restrictionDetails: {
    title: "Restriction Details",
    backButton: " Back to Restrictions",
  },
};
